import React from 'react';
import styled from 'styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import {Link} from 'react-router-dom';


function ImgSlider() {

    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slideToScroll: 1,
        autoplay: true
    }
    
    return (
        <Carousel {...settings}>
            <Wrap>
            <img src="/images/slider-badging.jpg" alt="slider-badging"/>
            </Wrap>

            <Wrap>
                <Link to="/detail">
                
                <img src="/images/slider-scale.jpg" alt="slider-scale"/>
                </Link>
                
            </Wrap>
            <Wrap>
                <img src="/images/slider-scales.jpg" alt="slider-scales"/>
            </Wrap>
            <Wrap>
                <img src="/images/slider-badag.jpg" alt="slider-badag"/>
            </Wrap>
            <Wrap>
            <img src="/images/slider-badging.jpg" alt="slider-badging"/>
            </Wrap>

            <Wrap>
                <Link to="/detail">
                
                <img src="/images/slider-scale.jpg" alt="slider-scale"/>
                </Link>
                
            </Wrap>
            <Wrap>
                <img src="/images/slider-scales.jpg" alt="slider-scales"/>
            </Wrap>
            <Wrap>
                <img src="/images/slider-badag.jpg" alt="slider-badag"/>
            </Wrap>
            <Wrap>
            <img src="/images/slider-badging.jpg" alt="slider-badging"/>
            </Wrap>

            <Wrap>
                <Link to="/detail">
                
                <img src="/images/slider-scale.jpg" alt="slider-scale"/>
                </Link>
                
            </Wrap>
            <Wrap>
                <img src="/images/slider-scales.jpg" alt="slider-scales"/>
            </Wrap>
            <Wrap>
                <img src="/images/slider-badag.jpg" alt="slider-badag"/>
            </Wrap>

        </Carousel>
    )
}

export default ImgSlider

const Carousel = styled(Slider)`
    margin-top: 20px;

    ul li button {
        &:before{
            font-size: 12px;
            color: rgb(150, 158, 171);
        }
    }

    li.slick-active button::before {
        color: rgb(150, 158, 171);
    }

    .slick-list {
        overflow: visible;
    }

    button {
        z-index: 1;
    }

`


const Wrap = styled.div `
    img{
        border: 4px solid transparent;
        border-radius: 4px;
        width: 100%;
        height: 100%;
        box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
        rgb(0 0 0 / 73%) 0px 16px 10px -10px;

        &:hover {
            border: 4px solid rgba(249, 249, 249, 0.8);
        }
    }
`